// ✅ Professional Sign-in Side Layout (MUI)
// Keeps your existing login logic intact

import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

import {
  Grid,
  Paper,
  Box,
  TextField,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(form);
      navigate("/");
    } catch {
      alert("Login failed");
    }
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      
      {/* LEFT IMAGE PANEL */}
      <Grid
        item
        xs={false}
        md={7}
        sx={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1503376780353-7e6692767b70)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* RIGHT LOGIN PANEL */}
      <Grid item xs={12} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 6,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Lekhani
          </Typography>

          <Typography variant="h6" mb={3}>
            Sign in
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email Address"
              value={form.email}
              onChange={(e) =>
                setForm({ ...form, email: e.target.value })
              }
            />

            <TextField
              margin="normal"
              required
              fullWidth
              label="Password"
              type="password"
              value={form.password}
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
            />

            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                py: 1.4,
                background:
                  "linear-gradient(135deg,#6366F1,#8B5CF6)",
              }}
            >
              Sign In
            </Button>

            <Typography variant="body2" color="text.secondary">
              © Lekhani {new Date().getFullYear()}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}